import React from "react";
import "./ListingsPreviewGrid.scss";
import { thumbImgProps, fallbackToOriginal } from "../../utils/imageUrl";
import {
  DEFAULT_LISTING_IMG,
  getListingThumb,
  getStablePosterTheme,
  getPosterTitleSizeClass,
  isWantedListing,
  formatCurrencyLabel,
  shouldShowBoostBadge,
} from "./listingDisplay";

// Deliberately its own small tile markup rather than reusing the dedicated
// "Оголошення" tab's <div className="ads-grid">/.ad-card JSX verbatim —
// that tab's card carries extra chrome (meta row with condition/exchange
// badges) this "image first, title, price, minimum noise" preview doesn't
// want. Same data, same helpers (imported from SearchResults, not
// duplicated), intentionally lighter markup.
const ListingTile = ({ item, onOpen }) => {
  const title = item.title || item.description || "Оголошення";
  const thumb = getListingThumb(item);
  const wanted = isWantedListing(item);
  const theme = getStablePosterTheme(item, title);
  const sizeClass = getPosterTitleSizeClass(title);
  const currencyLabel = formatCurrencyLabel(item.currency || "ГРН");

  const t = String(item?.type || "").toLowerCase();
  const isExchange = t === "exchange" || !!item?.exchangeFor;
  const isFree = t === "free" || Number(item?.price) === 0;

  return (
    <button
      type="button"
      className="listings-preview-tile"
      onClick={() => onOpen(item)}
    >
      <div className="listings-preview-tile__thumb">
        {shouldShowBoostBadge(item) && (
          <span className="ad-boost-badge">Піднято</span>
        )}

        {thumb ? (
          <img
            {...thumbImgProps(thumb, "(max-width: 600px) 50vw, (max-width: 1200px) 33vw, 320px")}
            alt={title}
            onError={fallbackToOriginal(thumb, DEFAULT_LISTING_IMG)}
          />
        ) : wanted ? (
          <div className={`ad-poster ad-poster--${theme}`}>
            <div className="ad-poster__glow" />
            <div className={`ad-poster__title ${sizeClass}`}>{title}</div>
          </div>
        ) : (
          <img src={DEFAULT_LISTING_IMG} alt={title} />
        )}
      </div>

      <div className="listings-preview-tile__title">{title}</div>

      <div className="listings-preview-tile__price">
        {wanted ? (
          <span className="listings-preview-tile__badge">Шукаю</span>
        ) : isExchange ? (
          "Обмін"
        ) : isFree ? (
          "Безкоштовно"
        ) : typeof item.price === "number" ? (
          `${item.price} ${currencyLabel}`
        ) : (
          "—"
        )}
      </div>
    </button>
  );
};

const ListingsPreviewGrid = ({ items, loading, error, onOpen, onShowMore, hideHeading = false, emptyText = "Нічого не знайдено" }) => {
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <div className="listings-preview">
      {!hideHeading && (
        <div className="section-head">
          <h3 className="section-title">Оголошення</h3>

          {hasItems && onShowMore && (
            <button type="button" className="section-more-btn" onClick={onShowMore}>
              Показати більше
            </button>
          )}
        </div>
      )}

      {loading && !hasItems && (
        <div className="listings-preview__grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div className="listings-preview-tile shimmer" key={`lst-skel-${i}`}>
              <div className="listings-preview-tile__thumb" />
            </div>
          ))}
        </div>
      )}

      {error && <div className="error">{error}</div>}

      {hasItems && (
        <div className="listings-preview__grid">
          {items.map((item) => (
            <ListingTile
              key={String(item.listingId || item.id)}
              item={item}
              onOpen={onOpen}
            />
          ))}
        </div>
      )}

      {!loading && !hasItems && !error && (
        <p className="listings-preview__empty">{emptyText}</p>
      )}
    </div>
  );
};

export default ListingsPreviewGrid;
